import React from "react";
import { ReportsContainer, ReportsHeading, ReportsTabs } from "./reports.styled";
import { TabsProps } from "antd";
import {
  AcademicRecord,
  CurrentPeriodGrades,
  ScholarshipHistory,
  StatementOfAccount,
} from "../../components";

const Reports = () => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Calificaciones del periodo actual`,
      children: <CurrentPeriodGrades />,
    },
    {
      key: "2",
      label: `Récord académico`,
      children: <AcademicRecord />,
    },
    {
      key: "3",
      label: `Historial de becas`,
      children: <ScholarshipHistory />,
    },
    {
      key: "4",
      label: `Estado de cuenta`,
      children: <StatementOfAccount />,
    },
  ];
  return (
    <ReportsContainer>
      <ReportsTabs
        defaultActiveKey="1"
        items={items}
        tabBarStyle={{
          flexDirection: "row-reverse",
          width: "100%",
          justifyContent: "end",
          marginBottom: "30px",
          marginTop: "30px",
        }}
        tabBarExtraContent={<ReportsHeading level={2}>Reportes</ReportsHeading>}
      />
    </ReportsContainer>
  );
};

export default Reports;
